var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7770.291 -10557.656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7769.039 10583.283)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.033,236.57a19.537,19.537,0,0,1,1.142,5.7,19.183,19.183,0,0,1-31.581,15.524l-9.15,14.651a73.671,73.671,0,0,0,23.726,3.7c22.953,0,41.554-9.2,41.554-20.56,0-8.578-10.614-15.923-25.691-19.01",
    transform: "translate(-106.546 -132.186)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.407,115.38l10.752,9.8,20.595-20.6h-3.311a16.476,16.476,0,0,1-16.224-19.627l-11.93,11.93c1-3.672,2.09-7.741,3.083-11.669,2.445-9.7,8-16.306,15.631-18.588,7.259-2.168,16.1-.377,25.42,4.9l11.349,0c-13.78-10.4-27.249-14.271-38.56-10.893-9.825,2.938-16.892,11.122-19.9,23.044-2.206,8.74-4.891,18.225-6.038,22.214l-4.5,4.5a19.046,19.046,0,0,1,13.64,4.979",
    transform: "translate(-89.841 -59.449)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.338,213.474a10.162,10.162,0,0,1-.032,5.939l.487.445a13.847,13.847,0,0,0,18.664-20.46l-44.82-40.847a13.847,13.847,0,0,0-18.665,20.46l23.518,21.433,15.239,6.724a10.165,10.165,0,0,1,5.609,6.306M210.1,175.311a6.745,6.745,0,1,1,6.428-7.045,6.744,6.744,0,0,1-6.428,7.045",
    transform: "translate(-80.679 -98.662)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.2,72.513l-9.439,5.568a16.46,16.46,0,0,1,5.539,3.653,16.7,16.7,0,0,1,1.97,2.384l3.656-4.345h9.349l4.227-7.26Z",
    transform: "translate(-152.262 -64.814)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.526,100.2A11.189,11.189,0,0,0,281.7,111.373h41.758a11.168,11.168,0,0,0,0-22.336l-41.76,0A11.191,11.191,0,0,0,270.526,100.2m18.981,0a6.745,6.745,0,1,1-6.742-6.744,6.745,6.745,0,0,1,6.742,6.744",
    transform: "translate(-111.097 -71.598)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.6,135.377H380.2l-9.439-5.569a16.42,16.42,0,0,0,5.54-3.653,16.6,16.6,0,0,0,1.969-2.38l3.656,4.342h19Z",
    transform: "translate(-152.261 -85.865)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.206)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.522,114.452,128.1,110.8a5.61,5.61,0,0,0-1.482-.725l-1.688-.717c7.235-20.925-3.062-40.544-21.158-46.342A31.564,31.564,0,0,0,94.109,61.5c-15.5,0-29.225,11.425-32.934,24.608a4.266,4.266,0,0,0-.462-.021,6.379,6.379,0,0,0-2.083.347,6.085,6.085,0,0,0-3.883,3.947A6.309,6.309,0,0,0,58.871,98.3l3.672,1.156A29.647,29.647,0,1,0,118.3,117l11.551,3.636a3.531,3.531,0,0,0,1.043.167,1.768,1.768,0,0,0,1.794-1.071l1.15-3.781a1.578,1.578,0,0,0-.32-1.5m-16.042-4.525L64.3,93.2a.726.726,0,0,1-.12-1.334,6.512,6.512,0,0,0,3.248-4C70.175,78.122,80.934,68.028,94.186,68a25.19,25.19,0,0,1,7.6,1.207,26.845,26.845,0,0,1,15.96,13.634c3.61,7.215,3.979,15.878,1.034,24.4a7.1,7.1,0,0,0-.357,2.009c-.011.246-.522.881-.944.68",
    transform: "translate(-22.362 -61.496)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.163,245.038a3.632,3.632,0,0,0-1.614-5.239L173.03,220.154a3.619,3.619,0,0,0-4.523,1.369L148.868,252.3l3.441,8.1,20.64-32.351,37.843,16.7L195,270.038a17.253,17.253,0,0,1,5.436,5Z",
    transform: "translate(-61.135 -126.524)",
    fill: "#2a293a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.384,267.593l-6.179-16.4a3.627,3.627,0,0,0-6.789,2.557l4.868,12.926-29.639-3.006L71.64,226.007c-6.569-16.167-18.094-23.148-30.614-23.148-17.193,0-30.159,10.075-33.791,33L0,287.5H54.42L35.651,249.341l8.456-2.309c4.732,9.786,12.282,25.4,16.726,34.454,3.233,6.606,8.32,10.325,14.96,10.325h45.627c8.842,0,14.016-4.307,14.016-12.3,0-6.263-3.216-10.733-10.051-11.916",
    transform: "translate(0 -119.549)",
    fill: "#2a293a"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.663 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.148 54.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.994,
    height: 13.994,
    transform: "translate(0 47.24)",
    fill: "#faca2a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.994,
    height: 34.984,
    fill: "#faca2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.787,140.744v0H10.045A10.048,10.048,0,0,1,0,130.7a9.921,9.921,0,0,1,1.406-5.123l14.718-25.231,3.646,2.151h4.1l-15.748,27-.027.049-.029.047a2.165,2.165,0,0,0-.284,1.11,2.272,2.272,0,0,0,2.269,2.27H150.788a2.269,2.269,0,0,0,2.268-2.267,2.3,2.3,0,0,0-.33-1.194l1.877-1.124-1.884,1.1L82.4,8.935a2.3,2.3,0,0,0-1.985-1.155H80.4a2.238,2.238,0,0,0-1.934,1.113l-.025.037-.022.042v.006L34.549,84.185H25.574l-.015-.019L71.731,5.014l.03-.05A10.046,10.046,0,0,1,89.11,5l70.324,120.562v.01a10.056,10.056,0,0,1-8.647,15.171Z",
    transform: "translate(0 0)",
    fill: "#faca2a",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 250,
    transform: "translate(-7770.291 10557.656)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrong);
export default __webpack_public_path__ + "static/media/icon_wrong.b4df8ff9ac03efd93a589a09af205487.svg";
export { ForwardRef as ReactComponent };